import { Job } from './Job';
/**
 * A transcription job with its attachments
 */
export class JobWithAttachments extends Job {
}
